import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Typography from "@material-ui/core/Typography";
import TableContainer from "@material-ui/core/TableContainer";
import {KIcon} from "@kyburz/kdesign-system";

import Popper from "@material-ui/core/Popper";

const useStyle = makeStyles((theme) => ({
  headingTitle: {
    color: theme.palette.grey[500],
  },
  table: {
    minWidth: 650,
  },
  popper: {
    borderRadius: "4px",
    padding: "2px 4px",
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}));

const SimplePopper = ({ data }) => {
  const classes = useStyle();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popper" : undefined;

  return (
    <div>
      <div aria-describedby={id} onClick={handleClick}>
        <span>
          <KIcon icon="info" size={16} color="black" />
        </span>
      </div>
      <Popper id={id} open={open} anchorEl={anchorEl}>
        <div className={classes.popper}>
          <pre>{JSON.stringify(data, null, 2)}</pre>
        </div>
      </Popper>
    </div>
  );
};

interface Props {
  data: any;
  valueAccess: (value) => string;
  withInfo?: boolean;
  popperAccess?: (value) => void;
}

const MetricsTable = ({
  data,
  valueAccess,
  withInfo = false,
  popperAccess = () => {},
}: Props) => {
  const classes = useStyle();
  const formattedData = data[0] ? data : [data];

  return (
    <TableContainer>
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableBody>
          {formattedData?.map((row, index) => {
            const formattedRow = row[0] ? row : [row];
            return (
              <TableRow key={index}>
                {formattedRow?.map((cell) => (
                  <React.Fragment key={cell.label}>
                    <TableCell>
                      <Typography
                        variant="caption"
                        className={classes.headingTitle}
                      >
                        {cell.label}
                      </Typography>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="body2">
                          {valueAccess(cell)?.toString()}
                        </Typography>
                        {withInfo ? (
                          <div>
                            <SimplePopper data={popperAccess(cell)} />
                          </div>
                        ) : null}
                      </div>
                    </TableCell>
                  </React.Fragment>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default MetricsTable;
